module.exports = __webpack_public_path__ + "static/media/programoperacyjny.31ee01d8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/programoperacyjny.jpeg
// module id = 631
// module chunks = 0